import { lazyLoad } from 'utils/loadable';

export const UsefulInfoCategorySortListPage = lazyLoad(
  () => import('./index'),
  module => module.UsefulInfoCategorySortListPage,
);
